<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-users"
        title="Gutachter"
        @save="saveFirmAppraisers">
        <csp-desktop-info-card-element
            :allow-appraiser-deselect="canDeselectAppraisers"
            class="col-12"
            :form-context="formContext"
            label="Gutachter"
            :max-height="550"
            open-direction="auto"
            property="appraisers"
            type="appraiserselect"/>
    </csp-desktop-info-card>
</template>
<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmAppraisers',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            canDeselectAppraisers() {
                return this.formContext.permissions.canDeselectAppraisers === true;
            },
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            saveFirmAppraisers(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmAppraisers(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
